import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { Layout, Spin, Drawer } from 'antd';
import {
    selectSummary,
    selectVendor,
    selectBroker,
    resetAllFilters
} from 'store/order';
import { Status } from './Status';
import { Filters as OrderFilters } from './Filters';
import { Vendors } from './Vendors';
import { OrderGrid } from './grid/OrderGrid';
import { ItemCount } from './ItemCount';
import useIsMobile from 'components/hooks/useIsMobile';
const { Header, Content, Sider, Footer } = Layout;

const OrderPage: React.FC = () => {

    const dispatch = useAppDispatch();
    const isMobile = useIsMobile();
    const orderSummary = useAppSelector(selectSummary);
    const selectedVendor = useAppSelector(selectVendor);
    const selectedBroker = useAppSelector(selectBroker);
    const [vendorDrawerOpen, setVendorDrawerOpen] = React.useState(false);

    React.useEffect(() => {
        setVendorDrawerOpen(false);
    }, [selectedVendor, selectedBroker]);

    React.useEffect(() => {
        document.title = `Order | ${globalThis.showTitle}`;
    }, []);

    React.useEffect(() => {
        setNotification(true);
        setTimeout(() => {
            setNotification(false);
        }, 1000);

    }, [orderSummary]);

    const [notification, setNotification] = React.useState(false);

    return (
        <React.Fragment>
            {!isMobile && (
                <Sider width={250} theme="light"
                    style={{
                        overflowY: 'auto',
                        position: 'sticky',
                        top: 0,
                        borderRight: '1px solid #d9d9d9'
                    }}
                >
                    <Vendors />
                </Sider>
            )}
            <Layout>
                <Header className="order-header">
                    <OrderFilters isMobile={isMobile} onVendorsClick={() => setVendorDrawerOpen(true)} />
                </Header>
                <Content id="order-grid">
                    <OrderGrid />
                </Content>
                <Footer>
                    <div className="item-count">
                        <ItemCount />
                    </div>
                    <div className="order-status">
                        <Status />
                    </div>
                    <div className="order-notification">
                        <div className={notification ? 'show' : ''}>Order Saved<span>.</span><span>.</span><span>.</span></div>
                    </div>
                </Footer>
            </Layout>
            {isMobile && (
                <Drawer title={<span style={{ cursor: 'pointer' }} onClick={() => { dispatch(resetAllFilters()); setVendorDrawerOpen(false); }}>ALL VENDORS</span>} placement="left" onClose={() => setVendorDrawerOpen(false)} open={vendorDrawerOpen} width={280}>
                    <Vendors />
                </Drawer>
            )}
        </React.Fragment >
    );
}
export default OrderPage;
